import { combineReducers } from 'redux';
import event from './Event';
export default combineReducers({
  event: event
});